/* import __COLOCATED_TEMPLATE__ from './column-selector.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

/**
 * ColumnSelector Component
 *
 * Dropdown menu for toggling column visibility.
 * Displays columns grouped by category with checkboxes.
 *
 * @param {Object} columnGroups - Object with columns grouped by category
 * @param {Array} visibleColumnIds - Array of currently visible column IDs
 * @param {Function} onToggle - Called with columnId when toggled
 * @param {Function} onClose - Called when selector should close
 */
export default class ColumnSelectorComponent extends Component {
  @action
  handleToggle(columnId) {
    this.args.onToggle?.(columnId);
  }

  @action
  handleBackdropClick(event) {
    // Close when clicking the backdrop
    if (event.target.classList.contains('column-selector-backdrop')) {
      this.args.onClose?.();
    }
  }

  @action
  handleClose() {
    this.args.onClose?.();
  }

  @action
  handleKeydown(event) {
    // Close on Escape key
    if (event.key === 'Escape') {
      event.preventDefault();
      this.args.onClose?.();
    }
  }

  @action
  setupKeyboardListener() {
    document.addEventListener('keydown', this.handleKeydown);
  }

  @action
  teardownKeyboardListener() {
    document.removeEventListener('keydown', this.handleKeydown);
  }
}
